import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import Card from '@material-ui/core/Card'
import Tooltip from 'ui/components/tooltip'
import Radio from '@material-ui/core/Radio'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import { ReactComponent as IconProvider } from 'assets/icons/provider.svg'
import { ReactComponent as IconClose } from 'assets/icons/close.svg'
import SvgIcon from '@material-ui/core/SvgIcon'
import useTranslation from 'hooks/useTranslations'
import useStyles from './styles'

const Notification = props => {
  const classes = useStyles()
  const {
    messageType,
    tag,
    title,
    text,
    time,
    onClick,
    isChecked,
    onChange,
    radioValue,
    vendorId,
    id,
  } = props

  const t = useTranslation()
  const tooltipUnread = t('tooltip:mark-unread')
  const tooltipRead = t('tooltip:mark-read')

  const handleClick = useCallback(
    e => {
      e.stopPropagation()
      e.preventDefault()
      onClick(id)
    },
    [id, onClick],
  )

  const handleChange = useCallback(
    e => {
      e.stopPropagation()
      e.preventDefault()
      onChange(id, isChecked)
    },
    [id, onChange, isChecked],
  )

  return (
    <Card
      elevation={1}
      className={classes.root}
      component={Link}
      to={`/app/vendors/${vendorId}`}
    >
      <div className={classes.header}>
        <SvgIcon
          component={IconProvider}
          className={clsx(
            classes.providerIcon,
            messageType === 'info' && classes.providerIconNeutral,
            messageType === 'success' && classes.providerIconPositive,
            messageType === 'alert' && classes.providerIconNegative,
          )}
        />
        <Typography variant="subtitle1" className={classes.tag}>
          {tag}
        </Typography>
        <div className={classes.actionsNotification}>
          <IconButton
            aria-label="close notification"
            className={classes.closeNotification}
            onClick={handleClick}
          >
            <SvgIcon
              component={IconClose}
              className={classes.iconCloseNotfication}
            />
          </IconButton>
          <Tooltip
            title={isChecked ? tooltipRead : tooltipUnread}
            arrow
            placement="top"
          >
            <Radio
              className={classes.radio}
              checked={isChecked}
              onClick={handleChange}
              value={radioValue}
              inputProps={{ 'aria-label': { radioValue } }}
              name="radio-notification"
              size="small"
              color="default"
            />
          </Tooltip>
        </div>
      </div>
      <div className={classes.content}>
        <Typography variant="body1" className={classes.title}>
          {title}
        </Typography>
        <Typography variant="subtitle1" className={classes.text}>
          {text}
        </Typography>
        <Typography variant="subtitle1" className={classes.time}>
          {time}
        </Typography>
      </div>
    </Card>
  )
}

Notification.propTypes = {
  messageType: PropTypes.any.isRequired,
  tag: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  time: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  onChange: PropTypes.func,
  isChecked: PropTypes.bool.isRequired,
  radioValue: PropTypes.string,
  vendorId: PropTypes.string,
  id: PropTypes.string,
}

export default Notification
